/* eslint-disable function-paren-newline */
import { RouteConfig } from 'vue-router'
import {
  ContractDetailsGuard,
  SRDetailsGuard,
} from '@/router/guards/ContractAndSRDetails'
import dashboardGuard from '@/router/guards/dashboard'
import myFamilyGuard from '@/router/guards/myFamily'
import profileGuard from '@/router/guards/profile'
import { RouteMeta } from '.'

const MyCaregivers = () =>
  import(
    /* webpackChunkName: "dashboard" */
    '@/views/dashboard/MyCaregivers.vue'
  )

const ServiceDetails = () =>
  import(
    /* webpackChunkName: "dashboard" */
    '@/views/dashboard/ServiceDetails.vue'
  )

const ContractDetails = () =>
  import(
    /* webpackChunkName: "dashboard" */
    '@/views/dashboard/ContractDetails.vue'
  )

const MyFamilyOverview = () =>
  import(
    /* webpackChunkName: "family" */
    '@/views/family/MyFamilyOverview.vue'
  )

const MyFamilyProfile = () =>
  import(
    /* webpackChunkName: "family" */
    '@/views/family/MyFamilyProfile.vue'
  )

const MyBookings = () =>
  import(
    /* webpackChunkName: "bookings" */
    '@/views/dashboard/MyBookings.vue'
  )

const PaymentMethod = () =>
  import(
    /* webpackChunkName: "paymentMethod" */
    '@/views/dashboard/PaymentMethod.vue'
  )

const dashboardRoutes: Array<RouteConfig> = [
  {
    path: '/meine-alltagshelfer',
    name: 'my-caregivers',
    component: MyCaregivers,
    beforeEnter: dashboardGuard,
    meta: <RouteMeta>{
      gtm: 'my caregiver overview',
      translateKey: 'PAGETITLE_GERMAN_MYCAREGIVERS',
      layout: 'dashboard',
      appSection: 'customer-dashboard',
    },
  },
  {
    path: '/meine-familie',
    name: 'my-family-overview',
    component: MyFamilyOverview,
    beforeEnter: myFamilyGuard,
    meta: <RouteMeta>{
      gtm: 'overview family profiles',
      translateKey: 'PAGETITLE_GERMAN_MYFAMILYOVERVIEW',
      layout: 'dashboard',
      appSection: 'customer-dashboard',
    },
  },
  {
    path: '/meine-buchungen',
    name: 'my-bookings',
    component: MyBookings,
    beforeEnter: dashboardGuard,
    meta: <RouteMeta>{
      gtm: 'my bookings overview',
      translateKey: 'MY_BOOKINGS',
      layout: 'dashboard',
      appSection: 'customer-dashboard',
    },
  },
  {
    path: '/zahlungsmethode',
    name: 'payment-method',
    component: PaymentMethod,
    beforeEnter: dashboardGuard,
    meta: <RouteMeta>{
      gtm: 'payment method',
      translateKey: 'SIDENAV_ITEM_PAYMENT_METHOD',
      layout: 'dashboard',
      appSection: 'customer-dashboard',
    },
  },
  {
    path: '/profil',
    name: 'my-family-profile',
    component: MyFamilyProfile,
    beforeEnter: profileGuard,
    meta: <RouteMeta>{
      gtm: 'family member profile',
      translateKey: 'PAGETITLE_GERMAN_MYFAMILYPROFILE',
      layout: 'dashboard',
      appSection: 'customer-dashboard',
    },
  },
  {
    path: '/meine-alltagshelfer/anfrage-details',
    name: 'meine-alltagshelfer-anfrage-details',
    component: ServiceDetails,
    props: true,
    meta: <RouteMeta>{
      gtm: 'my caregivers - details view',
      title: '',
      layout: 'dashboard',
      appSection: 'customer-dashboard',
    },
    beforeEnter: SRDetailsGuard,
  },
  {
    path: '/meine-alltagshelfer/contract-details',
    name: 'meine-alltagshelfer-contract-details',
    component: ContractDetails,
    props: true,
    meta: <RouteMeta>{
      gtm: 'my caregivers - details view',
      title: '',
      layout: 'dashboard',
      appSection: 'customer-dashboard',
    },
    beforeEnter: ContractDetailsGuard,
  },
]

export default dashboardRoutes
